export const LOADING_EMPLOYEE_OBJECTIVE = "LOADING_EMPLOYEE_OBJECTIVE";
export const SAVE_LOADING_EMPLOYEE_OBJECTIVE = "SAVE_LOADING_EMPLOYEE_OBJECTIVE";
export const GET_EMPLOYEE_OBJECTIVE = "GET_EMPLOYEE_OBJECTIVE";
export const FORM_FAIL = "FORM_FAIL";
export const EMPLOYEE_OBJECTIVE_FAIL = "EMPLOYEE_OBJECTIVE_FAIL";
export const LOADING_EMPLOYEE_OBJECTIVE_BY_ID = "LOADING_EMPLOYEE_OBJECTIVE_BY_ID";
export const GET_EMPLOYEE_OBJECTIVE_BY_ID = "GET_EMPLOYEE_OBJECTIVE_BY_ID";
export const SET_OBJECTIVES_MODIFIED = "SET_OBJECTIVES_MODIFIED";

